import usePaymentsTable from '@/hooks/table/usePaymentsTable';
import ErrorMessage from '../../error-message/ErrorMessage';
import { GenericTable } from '../common/generic-table/GenericTable';
import TableToolBar from './TableToolBar';
import AddPaymentModal from '@/pages/protected/Sales/SaleDetail/components/add-payment-modal/AddPaymentModal';

const PaymentsTable = () => {
  const {
    organization,
    paymentType,
    table,
    emptyData,
    filtering,
    setFiltering,
    paymentSelected,
    setPaymentSelected,
    openPaymentModal,
    setOpenPaymentModal,
    isLoading,
    mutate,
    isFetching,
    isError,
    isPending
  } = usePaymentsTable();

  if (isError) {
    return <ErrorMessage />;
  }

  return (
    <>
      <TableToolBar
        table={table}
        emptyData={emptyData}
        filtering={filtering}
        setFiltering={setFiltering}
        isFetching={isFetching}
      />

      <GenericTable table={table} isLoading={isLoading} />

      {openPaymentModal && paymentSelected && organization && paymentType ? (
        <AddPaymentModal
          paymentType={paymentType}
          open={openPaymentModal}
          organization={organization}
          onOpenChange={setOpenPaymentModal}
          sale={paymentSelected.sale}
          paymentSelected={paymentSelected}
          onSave={(formValues) => {
            mutate({ paymentId: paymentSelected?.id, data: formValues });
            setOpenPaymentModal(false);
            setPaymentSelected(null);
          }}
          loading={isPending}
        />
      ) : null}
    </>
  );
};

export default PaymentsTable;
